module.exports = __webpack_public_path__ + "img/gallery-img-1s.bc4f8bb9.jpg";